import { BeatLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

const JobMessage = job => {
  const { t } = useTranslation();

  if (job.status === 'FAILED') {
    const error_data = job.error || {};
    console.log(job.error);
    const error = error_data.error || error_data;
    const message = typeof error.message === 'string' ? error.message : 'Ocorreu um erro desconhecido';
    return <div className={`mt-5 alert alert-danger`}>{message}</div>;
  }

  const status_text = job.status === 'PENDING' ? t('bots.jobs.messages.waiting_device') : null;

  if (job.status !== 'WORKING' && job.status !== 'PENDING') {
    return null;
  }

  return (
    <div className={`ps-2 mt-3 mb-3 d-flex align-items-center text-muted`} style={{ height: 20 }}>
      <BeatLoader color="#333" size={5} />
      <i className="ms-3">{status_text || job.status_text}</i>
    </div>
  );
};

export default JobMessage;
